import React from 'react';
import { store } from '../index';
import { updateSectionStatus } from '../store/actions/AssessmentActions';
import { SECTION_STATUS_IN_PROGRESS } from '../const';

/**
 * Determine workflow and handle routing
 * @param {Object} params - Parameters object
 * @param {Array} params.sections - Assessment sections
 * @param {Array} params.problems - Assessment problems
 * @param {Array} params.mcqIds - MCQ IDs
 * @param {string} params.assessmentId - Assessment ID
 * @param {Object} params.routerHistory - React Router history object
 * @param {boolean} params.shouldRoute - Whether to perform routing (default: true)
 * @param {string} params.currentSectionId - Current section ID from store
 */
const determineWorkflow = ({
  sections,
  problems,
  mcqIds,
  assessmentId,
  routerHistory,
  shouldRoute = true,
  currentSectionId,
}) => {
  if (sections && sections.length > 0) {
    // Use IDs from sections instead of direct mcqIds/problemIds
    if (sections.length > 0 && shouldRoute && assessmentId) {
      // Get the current section using the currentSectionId parameter
      store.dispatch(updateSectionStatus(currentSectionId, SECTION_STATUS_IN_PROGRESS));
      const routePath = `/assessment/${assessmentId}/section/${currentSectionId}`;
      routerHistory.push(routePath);
    }
  } else if (problems && problems.length > 0) {
    // Get first problem ID directly from problems array
    if (problems.length > 0 && shouldRoute && assessmentId) {
      const firstProblemId = problems[0].id;
      routerHistory.push(`/assessment/${assessmentId}/problem/${firstProblemId}`);
    }
  } else if (mcqIds && mcqIds.length > 0) {
    // Get first MCQ ID directly from mcqIds array
    if (mcqIds.length > 0 && shouldRoute && assessmentId) {
      const firstMcqId = mcqIds[0].id;
      routerHistory.push(`/assessment/${assessmentId}/mcqs/${firstMcqId}`);
    }
  }
};

export default determineWorkflow;
